<template>
  <div class="WidgetNavbar">
    <div>
      <div id="overlay" @click="toggleTopNav()"></div>
      <div class="navbar-container">
        <div class="toggleBtn">
          <div @click="toggleTopNav()" class="right-margin-15" style="cursor: pointer">☰</div>
          <div class="flex-space-between" style="width: 100%">
            <div class="flex">
              <img src="../../assets/images/logo/logo1.png" class="cursor-pointer navbar-logo" style="margin: 0" />

              <img v-if="broker_data.logo" :src="serverHostName + '/' + broker_data.logo" :width="broker_data.width ? broker_data.width : '100px'" />
            </div>
            <div class="flex-center">
              <div class="right-margin-15">
                <div class="market-type-dropdown">
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      <div class="menu-links">
                        <span slot="reference" class="cursor-pointer capitalize">{{ selectedSegment }}</span>
                        <i class="el-icon-arrow-down el-icon--right cursor-pointer"></i>
                      </div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item class="menu-items" :class="selectedSegment == 'equity' ? 'active-link' : ''" v-on:click.native="(selectedSegment = 'equity'), $router.push('/equity-insights')">Equity</el-dropdown-item>
                      <el-dropdown-item class="menu-items" :class="selectedSegment == 'options' ? 'active-link' : ''" v-on:click.native="(selectedSegment = 'options'), $router.push('/options-insights')">Options</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <a href="https://www.youtube.com/watch?v=GaqXlTHpa2c" target="_blank">
                <img src="../../assets/images/Youtube Icon.png" style="cursor: pointer; width: 25px; height: 25px; margin-top: 0" alt="" />
              </a>
            </div>
          </div>
        </div>

        <div id="mobileNav">
          <div>
            <div class="navbar-menu" @click="$router.push('/equity-insights')" :style="[$route.path == '/equity-insights' ? { color: '#f77271', fontWeight: '700', fontSize: '13px' } : { color: '#fff' }]">Expert View</div>

            <div class="navbar-menu" @click="$router.push('/widget-sa-disclaimer')" :style="[$route.path == '/widget-sa-disclaimer' ? { color: '#f77271', fontWeight: '700', fontSize: '13px' } : { color: '#fff' }]">StockAnts Disclaimer</div>
            <div class="navbar-menu" v-if="broker_data.broker_name != 'XTS'" :style="[$route.path == '/widget-broker-disclaimer' ? { color: '#f77271', fontWeight: '700', fontSize: '13px' } : { color: '#fff' }]">
              <!-- @click="$router.push('/widget-broker-disclaimer')" -->
              Broker Disclaimer
            </div>

            <div class="navbar-menu" @click="$router.push('/widget-stockants-compliance')" :style="[$route.path == '/widget-stockants-compliance' ? { color: '#f77271', fontWeight: '700', fontSize: '13px' } : { color: '#fff' }]">StockAnts Compliance</div>
          </div>
        </div>
        <div class="banner">
          <div class="banner-inner">
            <div>
              <span class="login-text">Get Access to Bundle of Analysts with Price estimate tracking</span>
              <a :href="`${broker_data.link}/login?widget_access=${broker_data.widget_access}&brokerId=${broker_data.id}&bl_api_integrated=${broker_data.bl_api_integrated}`" target="_blank">
                <el-button class="btn-theme-gradient left-margin-10 top-margin-5">Log In</el-button>
              </a>
            </div>

            <!-- <p class="head">Tracking Price Estimates</p> -->

            <marquee width="95%">
              <div class="flex">
                <div class="features">
                  <img src="../../assets/images/Tick.svg" alt="" />
                  Bundle of SEBI Research Analyst
                </div>
                <div class="features">
                  <img src="../../assets/images/Tick.svg" alt="" />
                  15+ Daily Strategies
                </div>
                <div class="features">
                  <img src="../../assets/images/Tick.svg" alt="" />
                  Price estimate tracking of Advisory
                </div>
              </div>
            </marquee>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../../networkConfig';
import { WidgetHelperCallBack } from '../../mixins/WidgetCommonFunctions';
import { EventBus } from '../../eventBus';

export default {
  name: 'WidgetNavbar',
  mixins: [WidgetHelperCallBack],
  data() {
    return {
      serverHostName: serverHostName,
      showNavbar: false,
      selectedSegment: '',
    };
  },
  mounted() {
    if (this.$route.path.includes('/options-insights')) {
      this.selectedSegment = 'options';
    } else if (this.$route.path.includes('/equity-insights')) {
      this.selectedSegment = 'equity';
    }
  },
  created() {
    // Listen for the 'updateBrokerData' event and update the key value
    EventBus.$on('updateBrokerData', (newValue) => {
      this.broker_data = newValue;
    });
  },
  methods: {
    toggleTopNav() {
      this.showNavbar = !this.showNavbar;
      var mobileNav = document.getElementById('mobileNav');
      if (this.showNavbar) {
        mobileNav.style.width = '220px';
        mobileNav.style.display = 'block';
        document.getElementById('overlay').style.display = 'block';
        let body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'hidden';
      } else {
        mobileNav.style.width = '0px';
        mobileNav.style.display = 'none'; // Add this line to hide the mobileNav
        document.getElementById('overlay').style.display = 'none';
        let body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'auto';
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
@import '../../css/variable.scss';
@import '../../css/common.scss';

.WidgetNavbar {
  z-index: 2;
  background-color: #f4f4f4;
  .banner {
    text-align: center;
    color: #ffff;
    .banner-inner {
      height: 60px;
      width: 90%;
      margin: 0 auto;
      background-color: $secondary-theme-color;
      border-radius: 8px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .login-text {
      font-size: 1.1rem;
      font-weight: 700;
    }
    .features {
      font-size: 0.8rem;
      display: flex;
      align-items: center;
      margin-top: 7px;
      margin-left: 20px;

      font-weight: 600;
      img {
        margin-right: 7px;
      }
    }
  }

  .comming-soon-section {
    width: 100%;
    background: $primary-theme-color;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffff;
    font-size: 12px;
    text-align: center;
    font-weight: 700;

    .comming-soon-tag {
      font-size: 9px;
      margin: 5px 10px;
      padding: 5px 3px;
      border: 2px solid #ffff;
      border-radius: 5px;
    }
  }

  .navbar-container {
    background-color: #ffff;
    height: 90px;
    padding: 0px 20px;
    box-shadow: 0px 0px 12px 1px #8888884f;

    .list {
      display: flex;
      justify-content: space-between;

      .list-2 {
        .retail-tabs {
          background-color: #ffffff;
          border: 1px solid #b5b5b5;
          margin-right: 20px;
          border-radius: 25px;
          height: 26px;
          align-items: center;
        }
      }
    }

    .vertical-line {
      height: 35px;
      border-left: 1px solid;
    }

    .signup-btn {
      font-size: 12px;
      font-weight: 600;
      padding: 5px 15px;
      text-transform: uppercase;
      margin-left: 20px;
      cursor: pointer;
    }

    .invester-btn {
      font-size: 12px;
      padding: 5px 15px;
      border-radius: 25px;
      border: 1px solid $secondary-theme-color;
      background-color: $secondary-theme-color;
      font-weight: 500;
      color: #ffff;
      cursor: pointer;
      -webkit-transition: all 0.4s ease-in-out;
      transition: all 0.4s ease-in-out;
    }

    .toggleBtn {
      display: flex;
      align-items: center;
    }
  }

  .profile-pic {
    object-fit: cover;
    border-radius: 100%;
    margin-left: 20px;
    cursor: pointer;
  }

  .footer-nav {
    display: none;
    position: fixed;
    bottom: 0;
    padding: 10px 0 5px;
    left: 0;
    background-color: #ffff;
    width: 100%;
    box-shadow: 0px 0px 14px 1px #a3a3a3;
    z-index: 2;

    .footer-inner {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .sections {
        text-align: center;

        img {
          width: 23px;
          cursor: pointer;
        }

        img:hover {
          filter: brightness(0.5);
        }

        .label {
          margin: 3px 0;
          font-size: 0.8rem;
          color: #525050;
        }
      }
    }
  }

  #mobileNav {
    display: none;
    position: fixed;
    color: #ffff;
    top: 50px;
    left: 0;
    height: 100vh;
    transition: all 0.7s ease;
    overflow: auto;
    background: #161249;
    background: linear-gradient(0deg, #6664ab 0%, #4c4aab 34%, #534cd8 53%, #413de2 100%);
    z-index: 2;

    .invester-btn {
      font-size: 15px;
      padding: 8px 15px;
      border-radius: 10px;
      border: 1px solid #9c9af1;
      background-color: #9c9af1;
      font-weight: 500;
      margin: 25px;
      cursor: pointer;
    }

    .active-invester-btn {
      font-size: 15px;
      padding: 8px 15px;
      border-radius: 10px;
      font-weight: 500;
      margin: 25px;
      border: 1px solid #f9da7f;
      background-color: #f9da7f;
      color: #000;
      cursor: pointer;
    }

    .my-account {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 15px;
    }

    .signup-btn {
      font-size: 12px;
      font-weight: 600;
      padding: 5px 15px;
      text-transform: uppercase;
      margin-left: 20px;
      cursor: pointer;
    }

    .bottom-line {
      border-bottom: 1px solid #ffff;
      margin-bottom: 30px;
    }

    .navbar-menu {
      font-size: 12px;
      margin: 15px 25px;
      color: #ffff;
    }

    .social-icon {
      width: 22px;
      padding: 10px 5px;
    }

    .follow-txt {
      margin: 0 10px;
      font-size: 12px;
    }

    .bottom-section {
      position: absolute;
      bottom: 15px;
      text-align: center;
    }
  }

  #overlay {
    position: fixed;
    display: none;
    width: 100%;
    height: 105vh;
    overflow: hidden;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #00000082;
    z-index: 2;
    cursor: pointer;
  }

  .navbar-menu {
    font-weight: 500;
    font-size: 12px;
    margin: 12px;
    white-space: nowrap;
    color: #464343;
    cursor: pointer;
  }

  .navbar-logo {
    width: 170px;
  }

  @media screen and (min-width: 1073px) {
    .navbar-menu-section-mobile-view {
      display: none;
    }
  }

  @media screen and (max-width: 978px) {
    .navbar-container {
      padding: 0px 20px;
    }

    .navbar-container .list .list-2,
    .navbar-container .list .list-1 {
      display: none;
    }
  }

  @media screen and (max-width: 725px) {
    .footer-nav {
      display: block;
    }

    .banner .banner-inner {
      height: 75px;
      .login-text {
        font-size: 0.9rem;
        font-weight: 700;
      }
    }
  }

  @media screen and (max-width: 500px) {
    .navbar-logo {
      width: 100px;
    }

    .navbar-container {
      //   height: auto;
      padding: 5px 10px;
    }
  }

  @media screen and (max-width: 1283px) {
    .navbar-menu-section-desktop-view {
      display: none;
    }

    .navbar-menu-section-mobile-view {
      display: block;
    }
  }
}
</style>

<style lang="scss">
@import '../../css/variable.scss';
@import '../../css/common.scss';

// .WidgetNavbar {
.market-type-dropdown {
  background: #e72726;
  padding: 1px 8px 4px 12px;
  border-radius: 8px;
  position: relative;
  bottom: 2px;
}
.el-dropdown-menu__item {
  font-size: 12px !important;
}
i.el-icon-arrow-down.el-icon--right,
.menu-links {
  color: #ffff;
  font-weight: 700;
  font-size: 10px;
}
.menu-items:hover,
.active-link {
  color: #e72726 !important;
  font-weight: 500;
}

.active-link:hover {
  color: #e72726 !important;
}

.el-dropdown {
  font-size: 12px;
}
// }
</style>
